module.exports = __webpack_public_path__ + "img/smartinsurtech.57793211.png";